import { UserRoleTypeEnum } from "../services";
import { MData } from "../components/MaskMultiSelect";

export type StaffUser = {
  uuid: string;
  active: boolean;
  avatar: string;
  firstName: string;
  lastName: string;
  gender: string;
  birthDate?: Date;
  email: string;
  phone: string;
  roleType?: UserRoleTypeEnum;
  role?: string;
  workLocations?: MData[];
};

export const STAFF_USER_FORM_INITIAL_VALUES: StaffUser = {
  uuid: "",
  active: false,
  avatar: "",
  gender: "",
  lastName: "",
  firstName: "",
  birthDate: undefined,
  email: "",
  phone: "",
  roleType: "STAFF",
  role: "",
  workLocations: undefined,
};

